import { render, staticRenderFns } from "./DynamicAttributeSource.vue?vue&type=template&id=0d772c56&"
import script from "./DynamicAttributeSource.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports